import React from "react";
import "../styles/hero.css";

const Hero = ({
  title = "",
  subtitle = "",
  quote = "",
  quoteAuthor = "",
  showQuote = true,
}) => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{title}</h1>
        {subtitle && <p className="hero-subtitle">{subtitle}</p>}
        {showQuote && quote && (
          <blockquote className="hero-quote">
            <p>"{quote}"</p>
            {quoteAuthor && <footer>— {quoteAuthor}</footer>}
          </blockquote>
        )}
      </div>
    </section>
  );
};

export default Hero;
